import { IFormFieldSubmission } from "@common/redux/formSubmission/interface";
import { FieldProps } from "../FormFieldSelector/interfaces";
import { IGeolocationConfigurationClient, IGeolocationConfigurationServer } from "./interface";
import { displayErrorMessage } from "@utils/AlertMessage";
import { Search } from "@assets/images";

export const geolocationOptions = ["AUTOINPUT", "USERINPUT"];

export enum GeolocationEnumOptions {
  "AUTOINPUT" = "AUTOINPUT",
  "USERINPUT" = "USERINPUT"
}

export const locationDisplayType = ["MAP_VIEW", "TEXT_VIEW"];

export enum locationDisplayEnumType {
  MAP_VIEW = "Map View",
  TEXT_VIEW = "Text View",
}

export enum locationDisplayConditionEnum {
  MAP_VIEW = "MAP_VIEW",
  TEXT_VIEW = "TEXT_VIEW",
}

export const geolocationAutoPermission = ["READ", "EDIT"];

export enum geolocationAutoPermissionEnumType {
  READ = "Read",
  EDIT = "Edit",
}

export const transformGeolocationFieldConfigClientToServer = (
  fieldConfigClient: IGeolocationConfigurationClient
): IGeolocationConfigurationServer => {
    const {
    initialValue,
    placeHolder,
    fetchIpAddress,
    isDuplicateAllowed,
    isRequired,
    geolocationType,
    locationInputPermission,
    locationPlaceHolder,
  } = fieldConfigClient;
  const fieldConfigServer = {
    initialValue: initialValue,
    placeHolder: placeHolder,
    fetchIpAddress: fetchIpAddress || false,
    isDuplicateAllowed : isDuplicateAllowed,
    isRequired: isRequired,
    geolocationType: geolocationType,
    locationInputPermission : locationInputPermission,
    locationPlaceHolder: locationPlaceHolder,
  };
  return fieldConfigServer;
};

export const transformGeolocationConfigServerToClient = (
  fieldConfigServer: IGeolocationConfigurationServer
): IGeolocationConfigurationClient => {
  const {
    initialValue,
    placeHolder,
    fetchIpAddress,
    isDuplicateAllowed,
    isRequired,
    geolocationType,
    locationInputPermission,
    locationPlaceHolder,
  } = fieldConfigServer;
  const fieldConfigClient = {
    initialValue: initialValue,
    placeHolder: placeHolder,
    fetchIpAddress: fetchIpAddress || false,
    isDuplicateAllowed : isDuplicateAllowed,
    isRequired: isRequired,
    geolocationType: geolocationType,
    locationInputPermission : locationInputPermission,
    locationPlaceHolder: locationPlaceHolder,
  };
  return fieldConfigClient;
};

export const validateGeolocationFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission
): [boolean, string] => {
  const { isRequired } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;
  const latitude = fieldSubmissionValue?.geolocationValue?.latitude;
  const longitude = fieldSubmissionValue?.geolocationValue?.longitude;
  const address = fieldSubmissionValue?.geolocationValue?.address;
  if (isRequired && (!latitude || !longitude || !address)) {
    displayErrorMessage("geolocation permission is required please provide permission and reload the page");
    return [false, "This is a Required Field"];
  }
  return [true, ""];
};
